import { api } from '@/lib/api'
import { buildReportParams, downloadBlob } from '@/lib/api/reports'

/**
 * @param {{
 *   period?: string,
 *   customFrom?: string,
 *   customTo?: string,
 *   stylistId?: number | null,
 * }} [options]
 */
export async function fetchStaffCommissionReport(options = {}) {
  const params = {
    ...buildReportParams({
      period: options.period,
      from: options.customFrom,
      to: options.customTo,
    }),
    stylist_id: options.stylistId ?? undefined,
  }

  const { data } = await api.get('/reports/staff-commissions', { params })
  return data.data
}

/**
 * @param {{
 *   period?: string,
 *   customFrom?: string,
 *   customTo?: string,
 *   stylistId?: number | null,
 * }} [options]
 */
export async function exportStaffCommissionReportCsv(options = {}) {
  const params = {
    ...buildReportParams({
      period: options.period,
      from: options.customFrom,
      to: options.customTo,
    }),
    stylist_id: options.stylistId ?? undefined,
    format: 'csv',
  }

  const response = await api.get('/reports/staff-commissions/export', {
    params,
    responseType: 'blob',
  })

  const disposition = response.headers['content-disposition'] ?? ''
  const match = disposition.match(/filename="?([^";]+)"?/)
  const filename = match?.[1] ?? 'staff-commissions.csv'

  downloadBlob(filename, response.data)
}
